<div class="business-manager" [ngStyle]="themeStyle">
	<div class="business-manager-header">
		<div class="d-flex align-items-center gap-3">
			<i class="material-icons text-white" style="font-size: 28px;">business_center</i>
			<div>
				<h4 class="mb-0 text-white fw-bold ml-2">Workspace Navigator</h4>
				<p class="mb-0 text-white-50 small ml-2">
					Easily find and open any page or section. Use the search below to get where you need fast!
				</p>
			</div>
		</div>
		<button type="button" class="bm-close-btn" aria-label="Close" (click)="close()">
			<i class="material-icons">close</i>
		</button>
	</div>
	<div class="business-manager-body">
		<div class="search-container mb-4">
			<div class="search-input-wrapper">
				<i class="material-icons search-icon">search</i>
				<input
					type="text"
					class="form-control search-input"
					placeholder="Search routes or categories..."
					[(ngModel)]="searchTerm"
					(input)="onSearchChange()"
					autocomplete="off"
				/>
				<button
					*ngIf="searchTerm"
					class="btn btn-link clear-btn"
					(click)="clearSearch()"
					type="button"
				>
					<i class="material-icons">close</i>
				</button>
			</div>
		</div>

		<!--
		<div class="business-manager-stats mb-4">
			<div class="stat-card">
				<div class="stat-number">{{ filteredCategories.length }}</div>
				<div class="stat-label">Categories</div>
			</div>
			<div class="stat-card">
				<div class="stat-number">{{ getTotalRoutes() }}</div>
				<div class="stat-label">Available Routes</div>
			</div>
		</div>
		-->

		<div *ngIf="filteredCategories.length === 0" class="no-results">
			<i class="material-icons">search_off</i>
			<p>No routes found matching "{{ searchTerm }}"</p>
		</div>

		<div class="business-manager-grid">
			<ng-container *ngFor="let cat of filteredCategories">
				<div class="business-manager-category">
					<div class="category-header">
						<h6 class="category-title" [innerHTML]="highlightText(cat.title, searchTerm)"></h6>
						<span class="category-badge">{{ cat.count }}</span>
					</div>
					<ul class="business-manager-list">
						<li *ngFor="let r of cat.routes">
							<a (click)="navigate(r.path)" class="business-manager-link">
								<i class="material-icons">arrow_forward</i>
								<span [innerHTML]="highlightText(r.title, searchTerm)"></span>
							</a>
						</li>
					</ul>
				</div>
			</ng-container>
		</div>
	</div>
</div>
